import type {
  CheckoutClothingSelectedValue,
  CheckoutClothingService,
} from "@/scopes/checkout/domain/types/services/clothing";

export const clothingGenderSelector: (service: CheckoutClothingService, selectedId: string) => string[] =
  ({options, isNoneOption}, selectedId) => {
    return selectedId === isNoneOption ? [] : Array.from(new Set(Object.values(options).map(option => option.gender ?? '').sort()));
  }

export const clothingSizeSelector: (service: CheckoutClothingService, gender: string, selectedId: string) => string[] =
  ({options, isNoneOption}, gender, selectedId) => {
    let result: string[] = [];

    if (selectedId !== isNoneOption) {
      result = Array.from(new Set(Object.values(options).filter(option => option.gender === gender).map(option => option.size)))
    }

    return result;
  }

export const clothingServiceEditingValueByIdSelector: (service: CheckoutClothingService, participantId: string) => CheckoutClothingSelectedValue =
  ({editingSelectedValues}, participantId) => {
  return  editingSelectedValues[participantId]
}

export const clothingServiceOptionsListSelector: (
  service: CheckoutClothingService,
  gender?: string,
  size?: string,
) => string[] = ({ options, isNoneOption }, gender, size) => {

  return Object.values(options)
    .filter(option => (option.gender === gender))
    .filter(option => (option.size === size))
    .map(option => option.id)
    .concat(isNoneOption ? [isNoneOption] : []) ?? [];
};
